const options = {
  1: "col-end-1",
  2: "col-end-2",
};

export default function getGridColEnd(start) {
  return options[start];
}
